/*
 * Important pet info's quick-add sentences (SF 34, 34d, 67; the boards' note
 * N10). Tapping one adds its sentence to the end of the note with the part in
 * [brackets] selected, so typing replaces it. The rule is `utils/quickAdd.ts`,
 * shared with Review and book's note for the groomer.
 *
 * A fixed list from MPG to start. Nothing about behaviour here: that stays in
 * Aggressive behaviour, which only the groomer can lower (G6).
 */

import { quickAdd, type QuickAddTemplate } from './quickAdd';

export type { AddResult } from './quickAdd';

/** Pet.Note's length on the server (mpgadmin). */
export const NOTE_MAX = 500;

export type InfoIcon =
  | 'nervous'
  | 'dryer'
  | 'sensitive'
  | 'senior'
  | 'health'
  | 'allergy'
  | 'medication'
  | 'surgery'
  | 'noTreats'
  | 'firstGroom'
  | 'breed';

export type InfoTemplate = QuickAddTemplate<InfoIcon>;

export const INFO_TEMPLATES: InfoTemplate[] = [
  { key: 'nervous', label: 'Nervous', sentence: 'Nervous with [what]. Please go slow.' },
  { key: 'dryer', label: 'Dryer', sentence: 'Doesn’t like the dryer. Towel or low heat please.' },
  { key: 'sensitive', label: 'Sensitive spots', sentence: 'Sensitive about [paws / ears / tail].' },
  { key: 'senior', label: 'Senior', sentence: 'Senior with sore joints. Needs breaks and can’t stand for long.' },
  { key: 'health', label: 'Health', sentence: 'Has [condition]. Please be gentle with [area].' },
  { key: 'allergy', label: 'Allergy', sentence: 'Allergic to [what].' },
  { key: 'medication', label: 'Medication', sentence: 'On [medicine], [when].' },
  { key: 'surgery', label: 'Recent surgery', sentence: 'Had surgery on [date]. Please avoid [area].' },
  { key: 'noTreats', label: 'No treats', sentence: 'No treats please ([reason]).' },
  { key: 'firstGroom', label: 'First groom', sentence: 'First groom. Please make it a gentle, happy one.' },
  { key: 'breed', label: 'Breed not listed', sentence: 'Breed: [breed] (not in the list).' }
];

/** How many show before "+6 more". */
export const INFO_FIRST = 5;

export const infoNote = quickAdd(INFO_TEMPLATES, NOTE_MAX);

/**
 * `isAdded`: true when the note already holds this template's sentence.
 * `addTemplate`: the note with the sentence at the end, and the part to
 * select; `fill` replaces the first bracket (the breed sheet's "Add
 * “Kintamani” to important info").
 */
export const { isAdded, addTemplate } = infoNote;

export const templateOf = (key: InfoIcon): InfoTemplate => INFO_TEMPLATES.find(t => t.key === key)!;
